/**
 * This middleware checks if Maintenance Mode is enbaled and if so, returns a
 * 503.
 */
export default defineNuxtRouteMiddleware(() => {
  const { isFeatureEnabled } = useExperiment()
  const event = useRequestEvent()

  if (isFeatureEnabled('maintenanceMode') && event) {
    setResponseStatus(event, 503)
  }
})
